<template>
  <el-container class="LibraryForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-70"
        label-width="70px"
        :model="data"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="이름" prop="name">
              <el-input v-model="data.name" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="비고" prop="desc">
              <el-input v-model="data.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button v-if="!isNew" type="danger" @click="handleClickDelete"
        >삭 제</el-button
      >
      <el-button class="close-button" @click="handleClickClose"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";

export default {
  name: "LibraryForm",
  mixins: [form],
  data() {
    return {
      title: this.$t("title.library"),
      rules: {
        name: [{ required: true, message: "이름을 입력해 주세요." }],
      },
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    type_flag: {
      type: String,
      default: "1",
    },
  },
  computed: {
    isNew() {
      return this.data.id < 1;
    },
  },
  methods: {
    doRegister() {
      if (this.isNew) {
        this.data.type_flag = this.type_flag;
      }
      let api = this.isNew ? this.api.createLibrary : this.api.updateLibrary;
      let message = this.isNew
        ? this.$t("message.success_create")
        : this.$t("message.success_update");
      api(this.data).then((res) => {
        this.handleResponse(res, message);
      });
    },
    handleClickRegister() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleClickDelete() {
      this.$emit("deleted", this.data);
    },
    handleClickClose() {
      this.$emit("completed");
    },
    handleResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.$emit("completed", true);
    },
  },
};
</script>
